module.exports = __webpack_public_path__ + "img/general-2.f78fbdae.png";